// extracted by mini-css-extract-plugin
module.exports = {"Container":"MaskedText_Container__3N08a"};